import portalApi from './axios/portalAxios';

export const getTeacherFeesRequest = (teacherUserId) => {
  return portalApi.get(`/teacher-fees/${teacherUserId}`);
};

export const getTeacherFeeTypesRequest = () => {
  return portalApi.get('/admin/teacher-fee-types');
};

export const createTeacherFeeRequest = (data) => {
  return portalApi.post('/admin/teacher-fees', data);
};
